"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapInterior = void 0;
const get_component_from_chunk_by_id_1 = require("./components/get-component-from-chunk-by-id");
const get_component_from_item_by_id_1 = require("./components/get-component-from-item-by-id");
const get_component_values_1 = require("./components/get-component-values");
const legacy_mappers_1 = require("./legacy-mappers");
const mapInterior = (interiorChunk) => {
    var _a, _b;
    const interior = (_a = (0, get_component_values_1.getItemRelationItems)((0, get_component_from_chunk_by_id_1.getComponentFromChunkById)(interiorChunk, 'interior'))) === null || _a === void 0 ? void 0 : _a[0];
    if (!interior)
        return null;
    // Shape components
    const { images } = (_b = interior === null || interior === void 0 ? void 0 : interior.defaultVariant) !== null && _b !== void 0 ? _b : {};
    const interiorCode = (0, get_component_values_1.getSingleLineComponentValue)((0, get_component_from_item_by_id_1.getComponentFromItemById)(interior, 'code'));
    const type = (0, get_component_values_1.getSingleLineComponentValue)((0, get_component_from_item_by_id_1.getComponentFromItemById)(interior, 'interior'));
    // Chunk components
    const interiorPriceIncludingVat = (0, get_component_values_1.getNumericComponentValue)((0, get_component_from_chunk_by_id_1.getComponentFromChunkById)(interiorChunk, 'interiorPriceIncludingVat'));
    const isRecommended = (0, get_component_values_1.getBooleanComponentValue)((0, get_component_from_chunk_by_id_1.getComponentFromChunkById)(interiorChunk, 'isInteriorRecommended'));
    return {
        id: interior.id,
        name: interior.name,
        images: (0, legacy_mappers_1.mapImages)(images),
        interiorCode: interiorCode !== null && interiorCode !== void 0 ? interiorCode : null,
        type: type !== null && type !== void 0 ? type : null,
        additionalPrice: interiorPriceIncludingVat !== null && interiorPriceIncludingVat !== void 0 ? interiorPriceIncludingVat : null,
        isRecommended: isRecommended !== null && isRecommended !== void 0 ? isRecommended : null,
    };
};
exports.mapInterior = mapInterior;
//# sourceMappingURL=map-interior.js.map